import React from "react";
import { Eye } from "lucide-react";
import { resolvePlanDeveloppementImage } from "./planDeveloppementCardUtils";

export default function PlanDeveloppementCard({
    item,
    onDemander,
    onVoirDetails,
    showDemanderButton = true,
    variant = "collaborateur",
}) {
    const title = item.nom || item.titre || item.formation?.nom || item.title || "Formation";
    const image = resolvePlanDeveloppementImage(item);
    const isManagerVariant = variant === "manager";

    if (isManagerVariant) {
        return (
            <article className="plan-card plan-card--manager">
                <div className="plan-card__image"><img src={image} alt={title} /><span className="plan-badge">{item.badge || "Formation"}</span></div>
                <div className="plan-card__content plan-card__content--manager">
                    <h4 className="plan-card__manager-title">{title}</h4>
                    <p className="plan-card__manager-description">{item.description || "Aucune description."}</p>
                    {showDemanderButton && (
                        <button
                            type="button"
                            className="plan-card__manager-button"
                            disabled={item.disabled}
                            onClick={() => onDemander?.(item)}
                        >
                            {item.buttonLabel || "Demander"}
                        </button>
                    )}
                </div>
            </article>
        );
    }

    return (
        <article className="plan-card plan-card--formation">
            <div
                className="plan-card__image plan-card__image--clickable"
                onClick={() => onVoirDetails?.(item)}
                role={onVoirDetails ? "button" : undefined}
                tabIndex={onVoirDetails ? 0 : undefined}
                onKeyDown={(event) => {
                    if (!onVoirDetails) {
                        return;
                    }
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        onVoirDetails(item);
                    }
                }}
            >
                <img src={image} alt={title} />
                <span className="plan-badge">{item.badge || "Formation"}</span>
            </div>

            <div className="plan-card__content plan-card__content--formation">
                <div className="plan-card__title" title={title}>
                    {title}
                </div>
                <p className="plan-card__description">{item.description || "Aucune description."}</p>

                <div className="plan-card__meta">
                    <div className="plan-card__meta-row">
                        <span>Domaine :</span> {item.category || "—"}
                    </div>
                    <div className="plan-card__meta-row">
                        <span>Duree :</span> {item.duration || "—"}
                    </div>
                    <div className="plan-card__meta-row">
                        <span>Niveau :</span> {item.level || "—"}
                    </div>
                </div>

                {item.helper && <p className="plan-card__helper">{item.helper}</p>}

                <div className="plan-card__footer">
                    {showDemanderButton && (
                        <button
                            type="button"
                            className="plan-formation-submit-btn"
                            disabled={item.disabled}
                            onClick={() => onDemander?.(item)}
                        >
                            {item.buttonLabel || "Demander"}
                        </button>
                    )}

                    {onVoirDetails && (
                        <div className="plan-formation-card-actions">
                            <button
                                type="button"
                                className="plan-formation-action-btn"
                                onClick={() => onVoirDetails(item)}
                                title="Details"
                            >
                                <Eye size={18} />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </article>
    );
}
